import { gql } from '@apollo/client'
import { ARTIFACT_LABELS, DocDetails } from '@jusbrasil-web/docview/core'

import { Details_DocumentFragment } from './__generated__/details.graphql'

export interface DetailsProps {
  document: Details_DocumentFragment
}

const DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR')
const NUMBER_FORMATTER = new Intl.NumberFormat('pt-BR')

const formatNumber = (num: number | null | undefined) =>
  typeof num === 'number' ? NUMBER_FORMATTER.format(num) : null

export function Details(props: DetailsProps) {
  const { document } = props
  const { artifact, publisher, viewStat, date } = document

  const artifactLabel = ARTIFACT_LABELS[artifact as keyof typeof ARTIFACT_LABELS]

  const pairs = [
    {
      label: 'Data de publicação',
      value: DATE_FORMATTER.format(new Date(date || 0)),
    },
    {
      label: 'Sobre o autor',
      value: publisher?.introduction,
    },
    {
      label: 'Publicações',
      value: formatNumber(publisher?.documentsPublishedAmount),
    },
    {
      label: 'Seguidores',
      value: formatNumber(publisher?.followersAmount),
    },
    {
      label: 'Tipo de documento',
      value: artifactLabel.singularLabel,
    },
    {
      label: 'Visualizações',
      value: formatNumber(viewStat?.count),
    },
  ].filter((pair) => !!pair.value)

  return <DocDetails pairs={pairs} />
}

Details.fragments = {
  document: gql`
    fragment Details_document on Document {
      artifact
      publisher {
        introduction
        documentsPublishedAmount(artifacts: ["NOTICIAS", "ARTIGO", "MODELO_PECA"])
        followersAmount
      }
      viewStat {
        count
      }
      date
    }
  `,
}
